// PACKAGES
import React from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useContext } from 'use-context-selector'
import styled from 'styled-components'
// UI
import { Grid, Container, CircularProgress } from '@material-ui/core'
// COMPONENTS
import ApplicationCompleteCards from '../Messaging/ApplicationCompleteCards'
import ApplicationIncompleteCard from '../Messaging/ApplicationIncompleteCard'
// CONTEXTS
import { StepsContext } from '../../contexts/StepsContext'
// CONFIG
import { legacyApplyURL } from '../../config'
// SERVICES
import ProfileService from '../../services/profile'

const SuccessGrid = styled(Grid)`
  min-height: 100vh;
  text-align: center;
`

const AdditionalStepsDetails = ({ isLoading, clientName, url, username, postingId }) => {
  const [stepsContext] = useContext(StepsContext)

  const history = useHistory()
  const location = useLocation()

  const proceedToAdditionalSteps = () => {
    // Redirect to complete WOTC if WOTC available, check if feature is enabled before redirecting
    if (stepsContext.wotc && !stepsContext.wotc.isComplete && stepsContext.wotc.version === 'v2') {
      return history.push(`/postings/${postingId}/additional-steps/continue${location.search}`)
    }
    // Redirect to legacy otherwise
    const path = ProfileService.parseApplyUrl(url)
    window.location.replace(legacyApplyURL + path + location.search)
  }

  const renderSuccessCards = (additionalSteps) => {
    return additionalSteps.length
      ? <ApplicationIncompleteCard clientName={clientName} nextSteps={additionalSteps} onComplete={proceedToAdditionalSteps} />
      : <ApplicationCompleteCards clientName={clientName} username={username} />
  }

  return (
    <Container maxWidth='sm'>
      <SuccessGrid
        container
        direction='column'
        justifyContent='center'
        alignItems='stretch'
        spacing={4}
      >
        <Grid item xs={12} />
        {!isLoading
          ? renderSuccessCards(Object.keys(stepsContext).map(key => ({ ...stepsContext[key], key })))
          : <Grid item xs={12}><CircularProgress aria-label='Submitting Application' /></Grid>}
      </SuccessGrid>
    </Container>
  )
}

export default AdditionalStepsDetails
